import React, { useEffect, useState } from 'react';
import "./admin.css";
import menuIcon from "../../../assets/imgs/navbar/menu-open.svg";
import menuIconClicked from "../../../assets/imgs/navbar/menu-closed.svg";
import dogImg from "../../../assets/imgs/prepare-shipment/restrictions/dog.png";
import { AiFillCaretDown, AiFillContacts, AiOutlineQuestionCircle } from 'react-icons/ai';
import { FaUserCheck, FaUserShield, FaPen, FaFileInvoiceDollar, FaSignOutAlt, FaReceipt, FaBook, FaDesktop, FaQuestionCircle, FaUsers } from "react-icons/fa";
import { FaRectangleList, FaClock, FaMagnifyingGlassChart, FaAnchorLock, FaCrown, FaTruckFront , FaCreditCard} from "react-icons/fa6";
import { MdLocalAirport } from "react-icons/md";
import { BsFillPostcardFill } from "react-icons/bs";
import { TbTruckDelivery } from "react-icons/tb";
import MainBanner from '../../../components/dashboard/main-banner/main-banner';
import Usuarios from './usuarios/usuarios';
import Permisos from './permisos/permisos';
import Banners from './banners/banners';
import Textos from './textos/textos';
import Contactos from './contactos/contactos';
import Tarifario from './tarifario/tarifario';
import Bienvenido from './bienvenido/bienvenido';
import Cotizaciones from './cotizaciones/cotizaciones';
import PostalCodes from './codigos-postales/codigos-postales';
import Stations from './stations/stations';
import Service from './services/service';
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import Loading from '../components/loading/loading';
import UserNotFound from '../components/user-not-found/user-not-found';
import SessionExpired from '../../../components/session-expired/session-expired';
import PdfLogger from './pdf-logger/pdf-logger';
import InternationalStations from './internationalStations/international-stations';
import ShiftChange from './shift-change/shift-change';
import LoginReports from './login-reports/login-reports';
import KpiPersonal from './kpi-personal/kpi-personal';
import Shifts from './shifts/shifts';
import Counters from './counters/counters';
import SearchEngines from './search-engines/search-engines';
import Faq from './faq/faq';
import Advertisements from './advertisements/advertisements';
import { CgToolbarTop, CgToolbarRight } from "react-icons/cg";
import Notices from './notices/notices';
import PasswordTopClient from './password-top-client/password-top-client';
import TopClientAdmin from './top-client-admin/top-client-admin';
import CustomerCollection from './customer-collection/customer-collection';
import DOMPurify from "dompurify";
import CreditClients from "./credit-clients/credit-clients";

const sanitizeImageUrl = (url) => {
    if (!url || typeof url !== 'string') return '';

    const trimmed = url.trim();

    const isSafeProtocol = /^(https?:\/\/|\/|\.\/)/i.test(trimmed);

    const isDangerous = /^(javascript|data|vbscript):/i.test(trimmed);

    if (isSafeProtocol && !isDangerous) {
        return DOMPurify.sanitize(trimmed);
    }

    return '';
};

function Admin() {
    const { user, isAuthenticated, isLoading, logout, } = useAuth0();
    const [hasFetchedData, setHasFetchedData] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [imgUser, setImgUser] = useState(dogImg);
    const [stations, setStations] = useState([])

    useEffect(() => {
        const emailRegularExpression = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
        if (isAuthenticated && !hasFetchedData) {

            let email = user.sub.match(emailRegularExpression);

            if (email === null) {
                email = ['user', user.email]
            }

            const rawPicture = user?.picture;
            const safePicture = sanitizeImageUrl(rawPicture, dogImg);
            setImgUser(safePicture);
            axios.post(`${process.env.REACT_APP_URL_BACKEND}/api/user/login`, null,
                {
                    params: {
                        email: email[1],
                        key: process.env.REACT_APP_KEY,
                    },
                }
            )
                .then(response => {
                    localStorage.setItem('token', response.data.user.token);
                    localStorage.setItem('permissions', response.data.permissions);
                })
                .catch(error => {
                    console.error('error: ', error);
                    setShowAlert(true);
                })
                .finally(() => {
                    setHasFetchedData(true)
                })

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, hasFetchedData])

    const sectionNames = {
        Usuarios: 'Usuarios',
        Permisos: 'Permisos',
        Banners: 'Banners',
        Textos: 'Textos',
        Contactos: 'Contactos Web',
        Tarifario: 'Tarifario nacional',
        Cotizaciones: 'Cotizaciones',
        PostalCodes: 'Codigos Postales',
        Estaciones: 'Estaciones',
        Servicios: 'Servicios',
        PdfLogger: 'PDF Logger',
        InternationalStations: 'Estaciones Internacionales',
        ShiftChange: "Cambio de turnos",
        LoginReports: "Reportes de Login",
        KpiPersonal: "Kpi's Personal",
        Shifts: "Turnos",
        Counters: "Mostradores",
        SearchEngines: "Buscadores",
        Faq: "Preguntas Frecuentes",
        Advertisements: "Anuncios",
        Notices: "Avisos",
        TCP: "Password Cliente Top",
        TCAdmin: "Administrador Clientes Top",
        CustomerCollection: "Clientes Recolección",
        CreditClients: "Clientes Credito"
    };

    const getSectionIcon = (section) => {
        switch (section) {
            case 'Usuarios':
                return <FaUserCheck className="fs-5 align-self-center" />;
            case 'Permisos':
                return <FaUserShield className="fs-5 align-self-center" />;
            case 'Banners':
                return <BsFillPostcardFill className="fs-5 align-self-center" />;
            case 'Textos':
                return <FaPen className="fs-5 align-self-center" />;
            case 'Contactos':
                return <AiFillContacts className="fs-5 align-self-center" />;
            case 'Tarifario':
                return <FaFileInvoiceDollar className="fs-5 align-self-center" />;
            case 'Cotizaciones':
                return <FaReceipt className="fs-5 align-self-center" />;
            case 'PostalCodes':
                return <TbTruckDelivery className="fs-5 align-self-center" />;
            case 'Estaciones':
                return <MdLocalAirport className="fs-5 align-self-center" />;
            case 'Servicios':
                return <FaRectangleList className="fs-5 align-self-center" />;
            case 'PdfLogger':
                return <FaBook className="fs-5 align-self-center" />;
            case 'InternationalStations':
                return <MdLocalAirport className="fs-5 align-self-center" />;
            case 'ShiftChange':
                return <FaClock className="fs-5 align-self-center" />
            case 'LoginReports':
                return <FaBook className="fs-5 align-self-center" />
            case 'KpiPersonal':
                return <FaBook className="fs-5 align-self-center" />
            case 'Shifts':
                return <FaRectangleList className="fs-5 align-self-center" />
            case 'Counters':
                return <FaDesktop className="fs-5 align-self-center" />
            case 'SearchEngines':
                return <FaMagnifyingGlassChart className="fs-5 align-self-center" />
            case 'Faq':
                return <FaQuestionCircle className="fs-5 align-self-center" />
            case 'Advertisements':
                return <CgToolbarRight className='fs-5 align-self-center' />
            case 'Notices':
                return <CgToolbarTop className='fs-5 align-self-center' />
            case 'TCP':
                return <FaAnchorLock className="fs-5 align-self-center" />
            case 'TCAdmin':
                return <FaCrown className="fs-5 align-self-center" />
            case 'CustomerCollection':
                return <FaTruckFront className="fs-5 align-self-center" />
            case 'CreditClients':
                return <FaCreditCard className="fs-5 align-self-center" />
            default:
                return null;
        }
    };

    const getStations = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/stations`);
            if (res.data.code === 1) {
                const data = res.data.stations.filter((station) => station.add_quote === 1)
                setStations(data);
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getStations()
    }, [])

    if (stations.length !== 0) {
        localStorage.setItem('stations', JSON.stringify(stations));
    }

    const [selectedComponent, setSelectedComponent] = useState('');
    const handleMenuClick = (componentName) => {
        setSelectedComponent(componentName);
        closeMobileMenu();
    };

    const closeMobileMenu = () => setClick(false);
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const logoutAdmin = () => {
        localStorage.clear();
        logout({ logoutParams: { returnTo: process.env.REACT_APP_LOGOUT_URL } });
    }

    if (!isAuthenticated && !isLoading) {
        return (
            <>
                <SessionExpired />
            </>
        );
    }

    if (isLoading || !hasFetchedData) {
        return <Loading />
    }

    const userPermissions = (localStorage.getItem('permissions') || '').split(',');

    return (
        <div className="container-fluid p-0 m-0">
            {!showAlert ? (
                <>
                    <MainBanner />
                    <div className="d-flex">
                        <div className="admin-menu">
                            <div className="menu-icon-open-close" onClick={handleClick}>
                                <img src={click ? menuIconClicked : menuIcon} alt={click ? 'Closed Menu' : 'Open Menu'} />
                            </div>
                            <div className={click ? 'menu-admin active' : 'menu-admin'}>
                                <div className="d-flex flex-column">
                                    <div className=" d-flex justify-content-center pb-2">
                                        <img className="admin-profile-img" src={DOMPurify.sanitize(sanitizeImageUrl(imgUser, dogImg))} alt="Foto de perfil del usuario" />
                                    </div>
                                    <div className="d-flex justify-content-center pb-1">
                                        <button className="admin-profile-btn">Nombre<AiFillCaretDown className="ps-2 m-0 fs-5" /></button>
                                    </div>
                                    <div className="d-flex justify-content-center admin-profile-role pb-2 pb-md-0">
                                        <p>{user.nickname}</p>
                                    </div>
                                </div>

                                {userPermissions.includes('1') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Usuarios')}>
                                            <FaUserCheck className="fs-5" />
                                            <p className="ps-2 m-0">Usuarios</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('2') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Permisos')}>
                                            <FaUserShield className="fs-5" />
                                            <p className="ps-2 m-0">Permisos</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('3') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Banners')}>
                                            <BsFillPostcardFill className="fs-5" />
                                            <p className="ps-2 m-0">Banners</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('4') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Textos')}>
                                            <FaPen className="fs-5" />
                                            <p className="ps-2 m-0">Textos</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('5') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Contactos')}>
                                            <AiFillContacts className="fs-5" />
                                            <p className="ps-2 m-0">Contactos Web</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('6') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Tarifario')}>
                                            <FaFileInvoiceDollar className="fs-5" />
                                            <p className="ps-2 m-0">Tarifario nacional</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('7') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Cotizaciones')}>
                                            <FaReceipt className="fs-5" />
                                            <p className="ps-2 m-0">Cotizaciones</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('8') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('PostalCodes')}>
                                            <TbTruckDelivery className="fs-5" />
                                            <p className="ps-2 m-0">Codigos Postales</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('9') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Estaciones')}>
                                            <MdLocalAirport className="fs-5" />
                                            <p className="ps-2 m-0">Estaciones</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('10') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Servicios')}>
                                            <FaRectangleList className="fs-5" />
                                            <p className="ps-2 m-0">Servicios</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('11') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('PdfLogger')}>
                                            <FaBook className="fs-5" />
                                            <p className="ps-2 m-0">PDF Logger</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('12') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('InternationalStations')}>
                                            <MdLocalAirport className="fs-5" />
                                            <p className="ps-2 m-0">Estaciones Int...</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('24') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('ShiftChange')}>
                                            <FaClock className="fs-5" />
                                            <p className="ps-2 m-0">Cambio de turno</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('25') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('LoginReports')}>
                                            <FaBook className="fs-5" />
                                            <p className="ps-2 m-0">Reporte de Login</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('26') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('KpiPersonal')}>
                                            <FaBook className="fs-5" />
                                            <p className="ps-2 m-0">Kpi's Personal</p>
                                        </div>
                                    </div>
                                )}

                                {(userPermissions.includes('27') || userPermissions.includes('37') || userPermissions.includes('38')) && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Shifts')}>
                                            <FaRectangleList className="fs-5" />
                                            <p className="ps-2 m-0">Turnos</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('28') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Counters')}>
                                            <FaDesktop className="fs-5" />
                                            <p className="ps-2 m-0">Mostradores</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('35') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('SearchEngines')}>
                                            <FaMagnifyingGlassChart className="fs-5" />
                                            <p className="ps-2 m-0">Buscadores</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('36') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('Faq')}>
                                            <FaQuestionCircle className="fs-5" />
                                            <p className="ps-2 m-0">Preguntas Frecuentes</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('51') && (
                                    <div className='menu-admin-item'>
                                        <div className='text-menu-item' onClick={() => handleMenuClick('Advertisements')}>
                                            <CgToolbarRight className='fs-5' />
                                            <p className='ps-2 m-0'>Anuncios</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('58') && (
                                    <div className='menu-admin-item'>
                                        <div className='text-menu-item' onClick={() => handleMenuClick('Notices')}>
                                            <CgToolbarTop className='fs-5' />
                                            <p className='ps-2 m-0'>Avisos</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('57') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('TCP')}>
                                            <FaAnchorLock className="fs-5" />
                                            <p className="ps-2 m-0">Password Cliente Top</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('52') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('TCAdmin')}>
                                            <FaCrown className="fs-5" />
                                            <p className="ps-2 m-0">Administrador Clientes Top</p>
                                        </div>
                                    </div>
                                )}

                                {userPermissions.includes('54') && (
                                    <div className="menu-admin-item">
                                        <div className="text-menu-item" onClick={() => handleMenuClick('CustomerCollection')}>
                                            <FaTruckFront className="fs-5" />
                                            <p className="ps-2 m-0">Clientes Recolección</p>
                                        </div>
                                    </div>
                                )}

                    {userPermissions.includes('59') && (
                        <div className="menu-admin-item">
                            <div className="text-menu-item" onClick={() => handleMenuClick('CreditClients')}>
                                <FaCreditCard className="fs-5"/>
                                <p className="ps-2 m-0">Credito Clientes</p>
                            </div>
                        </div>
                    )}

                                <div className="menu-admin-item">
                                    <div className="text-menu-item" onClick={logoutAdmin}>
                                        <FaSignOutAlt className="fs-5" />
                                        <p className="ps-2 m-0">Cerrar sesión</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="menu-item-content">
                            <div className="main-panel">
                                <div className="main-panel-name d-flex">
                                    {getSectionIcon(selectedComponent)}
                                    <p className="fw-bold ps-2 m-0 align-self-center">{sectionNames[selectedComponent]}</p>
                                </div>
                                <div className="main-panel-body">
                                    {selectedComponent === 'Usuarios' && <Usuarios />}
                                    {selectedComponent === 'Permisos' && <Permisos />}
                                    {selectedComponent === 'Banners' && <Banners />}
                                    {selectedComponent === 'Textos' && <Textos />}
                                    {selectedComponent === 'Contactos' && <Contactos />}
                                    {selectedComponent === 'Tarifario' && <Tarifario />}
                                    {selectedComponent === '' && <Bienvenido />}
                                    {selectedComponent === 'Cotizaciones' && <Cotizaciones />}
                                    {selectedComponent === 'PostalCodes' && <PostalCodes />}
                                    {selectedComponent === 'Estaciones' && <Stations />}
                                    {selectedComponent === 'Servicios' && <Service />}
                                    {selectedComponent === 'PdfLogger' && <PdfLogger />}
                                    {selectedComponent === 'InternationalStations' && <InternationalStations />}
                                    {selectedComponent === 'ShiftChange' && <ShiftChange />}
                                    {selectedComponent === 'LoginReports' && <LoginReports />}
                                    {selectedComponent === 'KpiPersonal' && <KpiPersonal />}
                                    {selectedComponent === 'Shifts' && <Shifts />}
                                    {selectedComponent === 'Counters' && <Counters />}
                                    {selectedComponent === 'SearchEngines' && <SearchEngines />}
                                    {selectedComponent === 'Faq' && <Faq />}
                                    {selectedComponent === 'Advertisements' && <Advertisements />}
                                    {selectedComponent === 'Notices' && <Notices />}
                                    {selectedComponent === 'TCP' && <PasswordTopClient />}
                                    {selectedComponent === 'TCAdmin' && <TopClientAdmin />}
                                    {selectedComponent === 'CustomerCollection' && <CustomerCollection />}
                                    {selectedComponent === 'CreditClients' && <CreditClients />}
                        </div>
                            </div>
                        </div>
                    </div>
                </>
            ) :
                (
                    <UserNotFound />
                )
            }

        </div>
    )
}

export default Admin